import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Module } from "../services/firmware/firmware.service";

@Component({
  selector: 'dcc-view-module-version-modal',
  templateUrl: './view-module-version-modal.component.html',
  styleUrls: ['./view-module-version-modal.component.scss']
})
export class ViewModuleVersionModalComponent implements OnInit {
  @Output() refreshPage: EventEmitter<any> = new EventEmitter();
  @Output() closePage: EventEmitter<any> = new EventEmitter();
  @Input() moduleVersion: Module;

  loading = true;
  configJsonAvailable: boolean = false;

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  async ngOnInit() {
    this.prepareData();
  }

  prepareData() {
    if (this.moduleVersion.configurationSchema)
      this.configJsonAvailable = true;
  }

  close() {
    this.activeModal.close(false);
  }

  cancel() {
    this.refreshPage.emit();
    this.activeModal.close();
  }

  refreshAfterNewModuleVersion() {
    this.refreshPage.emit();
  }
}
